// extracted by mini-css-extract-plugin
module.exports = {"description":"AvatarDescription_description__39oai","name":"AvatarDescription_name__2zGqN","rol":"AvatarDescription_rol__39Lyu"};